"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchUploadcareFileUrls = exports.patchUploadcareUrl = exports.stripUploadcareUrlPatches = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.concat.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IMAGE_EFFECTS = ['brightness', 'exposure', 'gamma', 'contrast', 'saturation', 'vibrance', 'warmth', 'enhance', 'grayscale', 'invert', 'filter', 'blur', 'blur-region', 'sharp', 'overlay', 'rotate', 'flip', 'mirror']; // To make UC images behave correctly when copied to Zola, we add a few "patches" to cdn URLs before saving.
// These 'patches' can cause issues when used as the UC widget source, so this method strips them out.

var stripUploadcareUrlPatches = function stripUploadcareUrlPatches(uploadcareUrl) {
  if (!uploadcareUrl) return uploadcareUrl;
  return uploadcareUrl.replace(/-\/max_icc_size\/0\//, '').replace(/-\/format\/jpeg\//, '').replace(/-\/preview\/(\d+x\d+\/)?/, '');
};

exports.stripUploadcareUrlPatches = stripUploadcareUrlPatches;

var patchUploadcareUrl = function patchUploadcareUrl(url) {
  if (!url) return url;
  var newUrl = stripUploadcareUrlPatches(url);
  if (!newUrl) return null; // Uploadcare currently doesn't strip the original color profile when greyscale is applied.
  // As a fix, they suggested adding `max_icc_size/0` when greyscale is enabled.

  newUrl = newUrl.replace(/-\/grayscale\//, '-/grayscale/-/max_icc_size/0/');
  /**
   * If an image has effects applied, UC requires the "preview" param to be present or the image will break.
   * When that happens, the resulting image (the one copied to Zola) has its max dimension capped at 2048px,
   * which is too small. Our only option is to explicitly specify the jpeg format and a max size of 5000x5000.
   *
   * Source: https://uploadcare.com/docs/transformations/image/#dimensions
   */

  var hasEffectsApplied = IMAGE_EFFECTS.some(function (effect) {
    return (newUrl || '').includes("-/".concat(effect));
  });

  if (hasEffectsApplied) {
    newUrl = newUrl.concat('-/format/jpeg/-/preview/5000x5000/');
  }

  return newUrl;
};

exports.patchUploadcareUrl = patchUploadcareUrl;

var patchUploadcareFileUrls = function patchUploadcareFileUrls(uploadcareFile) {
  return _objectSpread(_objectSpread({}, uploadcareFile), {}, {
    cdnUrl: patchUploadcareUrl(uploadcareFile.cdnUrl),
    cdnUrlModifiers: patchUploadcareUrl(uploadcareFile.cdnUrlModifiers)
  });
};

exports.patchUploadcareFileUrls = patchUploadcareFileUrls;